import React from 'react';
import TranslationContent from '#/components/TranslationContent';
import { Modal } from '@jucy-ui/components';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import Button from '@mui/material/Button';
import type { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';

export type RefundInformationDialogProps = Omit<DialogProps, 'handleClose' | 'open'>;
export const RefundInformationDialog = ({ maxWidth = 'sm', ...props }: RefundInformationDialogProps) => {
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <sup>
                <IconButton
                    title="Show more information about refunds"
                    size="small"
                    color="error"
                    onClick={() => {
                        setOpen(true);
                    }}
                >
                    <InfoOutlineIcon fontSize="inherit" />
                </IconButton>
            </sup>

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                title="Refund information"
                maxWidth={maxWidth}
                showClose={true}
                titleIcon={<CurrencyExchangeIcon />}
                {...props}
            >
                <DialogContent>
                    <TranslationContent path="summary.refund.information" />
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={() => setOpen(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Modal>
        </>
    );
};

RefundInformationDialog.displayName = 'RatingGuideDialog';
